export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
	[K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
	[_ in K]?: never;
};
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
	  };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	/**
	 * The `Date` scalar type represents a date. The Date appears in a JSON
	 * response as an ISO8601 formatted string, without a time component.
	 */
	Date: { input: string; output: string };
	/**
	 * The `DateTime` scalar type represents a date and time in the UTC
	 * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
	 * string, including UTC timezone ("Z"). The parsed date and time string will
	 * be converted to UTC if there is an offset.
	 */
	DateTime: { input: string; output: string };
	/**
	 * The `Decimal` scalar type represents signed double-precision fractional
	 * values parsed by the `Decimal` library. The Decimal appears in a JSON
	 * response as a string to preserve precision.
	 */
	Decimal: { input: any; output: any };
	/**
	 * The `Json` scalar type represents arbitrary json string data, represented as UTF-8
	 * character sequences. The Json type is most often used to represent a free-form
	 * human-readable json string.
	 */
	Json: { input: any; output: any };
	/**
	 * The `Json` scalar type represents arbitrary json string data, represented as UTF-8
	 * character sequences. The Json type is most often used to represent a free-form
	 * human-readable json string.
	 */
	JsonString: { input: any; output: any };
};

export enum ActivityType {
	AGRICULTURE = 'AGRICULTURE',
	COMMERCE = 'COMMERCE',
	EMPLOYEE = 'EMPLOYEE',
	HOTEL = 'HOTEL',
	MANUFACTURING = 'MANUFACTURING',
	OTHER = 'OTHER',
	RESTAURANT = 'RESTAURANT',
	TRANSPORTATION = 'TRANSPORTATION'
}

export type AfAddress = {
	__typename?: 'AfAddress';
	error?: Maybe<Scalars['String']['output']>;
	isInHighRiskLocation?: Maybe<Scalars['Boolean']['output']>;
	isInsideOfPrison?: Maybe<Scalars['Boolean']['output']>;
	isNearToPrison?: Maybe<Scalars['Boolean']['output']>;
	isOutsideOfTerritory?: Maybe<Scalars['Boolean']['output']>;
	validatedFullAddress?: Maybe<Scalars['String']['output']>;
};

export type AfCurp = {
	__typename?: 'AfCurp';
	curp?: Maybe<Scalars['String']['output']>;
	dateOfBirth?: Maybe<Scalars['String']['output']>;
	error?: Maybe<Scalars['String']['output']>;
	gender?: Maybe<Scalars['String']['output']>;
	governmentName?: Maybe<Scalars['String']['output']>;
	isMexican?: Maybe<Scalars['Boolean']['output']>;
	isValid?: Maybe<Scalars['Boolean']['output']>;
};

export type AfEmail = {
	__typename?: 'AfEmail';
	deliverability?: Maybe<Scalars['String']['output']>;
	fraudScore?: Maybe<Scalars['Int']['output']>;
	hasRecentAbuseInTrullyNetwork?: Maybe<Scalars['Boolean']['output']>;
	isDisposable?: Maybe<Scalars['Boolean']['output']>;
	isFrequentComplainer?: Maybe<Scalars['Boolean']['output']>;
	isLeaked?: Maybe<Scalars['Boolean']['output']>;
	isSpamHoneypot?: Maybe<Scalars['Boolean']['output']>;
	isValid?: Maybe<Scalars['Boolean']['output']>;
	sanitizedEmail?: Maybe<Scalars['String']['output']>;
	spamTrapScore?: Maybe<Scalars['String']['output']>;
};

export type AfFaceRecognition = {
	__typename?: 'AfFaceRecognition';
	companiesSeen?: Maybe<Scalars['Int']['output']>;
	confidenceScore?: Maybe<Scalars['Float']['output']>;
	gender?: Maybe<Scalars['String']['output']>;
	isMarkedAsFraudInTrullyNetwork?: Maybe<Scalars['Boolean']['output']>;
	lastSeenInTrullyNetwork?: Maybe<Scalars['String']['output']>;
	timesSeenLastMonthInTrullyNetwork?: Maybe<Scalars['Int']['output']>;
	warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type AfIne = {
	__typename?: 'AfIne';
	curp?: Maybe<Scalars['String']['output']>;
	electoralKey?: Maybe<Scalars['String']['output']>;
	firstLastName?: Maybe<Scalars['String']['output']>;
	names?: Maybe<Scalars['String']['output']>;
	secondLastName?: Maybe<Scalars['String']['output']>;
	validThru?: Maybe<Scalars['String']['output']>;
};

export type AfIpAddress = {
	__typename?: 'AfIpAddress';
	blacklistedCount?: Maybe<Scalars['Int']['output']>;
	isBlacklisted?: Maybe<Scalars['Boolean']['output']>;
	isTorConnection?: Maybe<Scalars['Boolean']['output']>;
	isVpnConnection?: Maybe<Scalars['Boolean']['output']>;
};

export type AfLocationAndAddressDistance = {
	__typename?: 'AfLocationAndAddressDistance';
	level?: Maybe<Scalars['String']['output']>;
	observation?: Maybe<Scalars['String']['output']>;
};

export type AfPassport = {
	__typename?: 'AfPassport';
	citizenship?: Maybe<Scalars['String']['output']>;
	curp?: Maybe<Scalars['String']['output']>;
	dateOfBirth?: Maybe<Scalars['String']['output']>;
	expirationDate?: Maybe<Scalars['String']['output']>;
	lastNames?: Maybe<Scalars['String']['output']>;
	names?: Maybe<Scalars['String']['output']>;
	passportNumber?: Maybe<Scalars['String']['output']>;
};

export type AfPhoneNumber = {
	__typename?: 'AfPhoneNumber';
	carrier?: Maybe<Scalars['String']['output']>;
	city?: Maybe<Scalars['String']['output']>;
	country?: Maybe<Scalars['String']['output']>;
	fraudScore?: Maybe<Scalars['Int']['output']>;
	hasFraudulentBehavior?: Maybe<Scalars['Boolean']['output']>;
	hasRecentAbuseInTrullyNetwork?: Maybe<Scalars['Boolean']['output']>;
	isActive?: Maybe<Scalars['Boolean']['output']>;
	isDigitalPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
	isLeaked?: Maybe<Scalars['Boolean']['output']>;
	isSpammer?: Maybe<Scalars['Boolean']['output']>;
	isValid?: Maybe<Scalars['Boolean']['output']>;
	onWhatsapp?: Maybe<Scalars['Boolean']['output']>;
};

export type AfRfc = {
	__typename?: 'AfRfc';
	blacklistStatus?: Maybe<Scalars['String']['output']>;
	isValid?: Maybe<Scalars['Boolean']['output']>;
	observation?: Maybe<Scalars['String']['output']>;
	validatedRfc?: Maybe<Scalars['String']['output']>;
};

export type AntifraudAnalysis = {
	__typename?: 'AntifraudAnalysis';
	address?: Maybe<AfAddress>;
	clientId: Scalars['ID']['output'];
	curp?: Maybe<AfCurp>;
	email?: Maybe<AfEmail>;
	id: Scalars['ID']['output'];
	identityFraudScore?: Maybe<Scalars['Int']['output']>;
	ine?: Maybe<AfIne>;
	insertedAt: Scalars['DateTime']['output'];
	ipAddress?: Maybe<AfIpAddress>;
	label?: Maybe<Scalars['String']['output']>;
	location?: Maybe<AfAddress>;
	locationAndAddressDistance?: Maybe<AfLocationAndAddressDistance>;
	officialIdCurp?: Maybe<AfCurp>;
	officialIdFaceRecognition?: Maybe<AfFaceRecognition>;
	officialIdRfc?: Maybe<AfRfc>;
	passport?: Maybe<AfPassport>;
	pep?: Maybe<Array<Scalars['JsonString']['output']>>;
	phoneNumber?: Maybe<AfPhoneNumber>;
	rfc?: Maybe<AfRfc>;
	sanctions?: Maybe<Array<Scalars['JsonString']['output']>>;
	selfieAndOfficialIdMatch?: Maybe<Scalars['Boolean']['output']>;
	selfieFaceRecognition?: Maybe<AfFaceRecognition>;
	trullyInformation: TrullyInformation;
	updatedAt: Scalars['DateTime']['output'];
	warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type AntifraudAnalysisFilterClientId = {
	eq?: InputMaybe<Scalars['ID']['input']>;
	greaterThan?: InputMaybe<Scalars['ID']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	in?: InputMaybe<Array<Scalars['ID']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['ID']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AntifraudAnalysisFilterId = {
	eq?: InputMaybe<Scalars['ID']['input']>;
	greaterThan?: InputMaybe<Scalars['ID']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	in?: InputMaybe<Array<Scalars['ID']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['ID']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AntifraudAnalysisFilterIdentityFraudScore = {
	eq?: InputMaybe<Scalars['Int']['input']>;
	greaterThan?: InputMaybe<Scalars['Int']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['Int']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
	notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AntifraudAnalysisFilterInput = {
	and?: InputMaybe<Array<AntifraudAnalysisFilterInput>>;
	clientId?: InputMaybe<AntifraudAnalysisFilterClientId>;
	id?: InputMaybe<AntifraudAnalysisFilterId>;
	identityFraudScore?: InputMaybe<AntifraudAnalysisFilterIdentityFraudScore>;
	insertedAt?: InputMaybe<AntifraudAnalysisFilterInsertedAt>;
	label?: InputMaybe<AntifraudAnalysisFilterLabel>;
	not?: InputMaybe<Array<AntifraudAnalysisFilterInput>>;
	or?: InputMaybe<Array<AntifraudAnalysisFilterInput>>;
	selfieAndOfficialIdMatch?: InputMaybe<AntifraudAnalysisFilterSelfieAndOfficialIdMatch>;
	updatedAt?: InputMaybe<AntifraudAnalysisFilterUpdatedAt>;
};

export type AntifraudAnalysisFilterInsertedAt = {
	eq?: InputMaybe<Scalars['DateTime']['input']>;
	greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
	in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['DateTime']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
	notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AntifraudAnalysisFilterLabel = {
	eq?: InputMaybe<Scalars['String']['input']>;
	greaterThan?: InputMaybe<Scalars['String']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	ilike?: InputMaybe<Scalars['String']['input']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['String']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	like?: InputMaybe<Scalars['String']['input']>;
	notEq?: InputMaybe<Scalars['String']['input']>;
};

export type AntifraudAnalysisFilterSelfieAndOfficialIdMatch = {
	eq?: InputMaybe<Scalars['Boolean']['input']>;
	greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['Boolean']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
	notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AntifraudAnalysisFilterUpdatedAt = {
	eq?: InputMaybe<Scalars['DateTime']['input']>;
	greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
	in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['DateTime']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
	notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum AntifraudAnalysisSortField {
	CLIENT_ID = 'CLIENT_ID',
	ID = 'ID',
	IDENTITY_FRAUD_SCORE = 'IDENTITY_FRAUD_SCORE',
	INSERTED_AT = 'INSERTED_AT',
	LABEL = 'LABEL',
	SELFIE_AND_OFFICIAL_ID_MATCH = 'SELFIE_AND_OFFICIAL_ID_MATCH',
	UPDATED_AT = 'UPDATED_AT'
}

export type AntifraudAnalysisSortInput = {
	field: AntifraudAnalysisSortField;
	order?: InputMaybe<SortOrder>;
};

export type AntifraudAnalysisTrullyInformationInput = {
	city?: InputMaybe<Scalars['String']['input']>;
	colony?: InputMaybe<Scalars['String']['input']>;
	curp?: InputMaybe<Scalars['String']['input']>;
	dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
	email?: InputMaybe<Scalars['String']['input']>;
	externalNumber?: InputMaybe<Scalars['String']['input']>;
	firstLastName?: InputMaybe<Scalars['String']['input']>;
	internalNumber?: InputMaybe<Scalars['String']['input']>;
	municipalityOrDelegation?: InputMaybe<Scalars['String']['input']>;
	names?: InputMaybe<Scalars['String']['input']>;
	phoneNumber?: InputMaybe<Scalars['String']['input']>;
	postalCode?: InputMaybe<Scalars['String']['input']>;
	requestId?: InputMaybe<Scalars['String']['input']>;
	rfc?: InputMaybe<Scalars['String']['input']>;
	secondLastName?: InputMaybe<Scalars['String']['input']>;
	state?: InputMaybe<Scalars['String']['input']>;
	street?: InputMaybe<Scalars['String']['input']>;
	userId?: InputMaybe<Scalars['ID']['input']>;
};

/** The result of the :apply_antifraud_analysis mutation */
export type ApplyAntifraudAnalysisResult = {
	__typename?: 'ApplyAntifraudAnalysisResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<AntifraudAnalysis>;
};

export type ApproveRegistryInput = {
	deliberation: Scalars['String']['input'];
};

/** The result of the :approve_registry mutation */
export type ApproveRegistryResult = {
	__typename?: 'ApproveRegistryResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<Registry>;
};

/** The result of the :complete_proof_of_life mutation */
export type CompleteProofOfLifeResult = {
	__typename?: 'CompleteProofOfLifeResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<Registry>;
};

export type Correction = {
	__typename?: 'Correction';
	field: RegistryCorrectionField;
	message?: Maybe<Scalars['String']['output']>;
	section: RegistryCorrectionSection;
};

export enum Country {
	ABW = 'ABW',
	AFG = 'AFG',
	AGO = 'AGO',
	AIA = 'AIA',
	ALA = 'ALA',
	ALB = 'ALB',
	AND = 'AND',
	ANT = 'ANT',
	ARE = 'ARE',
	ARG = 'ARG',
	ARM = 'ARM',
	ASM = 'ASM',
	ATA = 'ATA',
	ATF = 'ATF',
	ATG = 'ATG',
	AUS = 'AUS',
	AUT = 'AUT',
	AZE = 'AZE',
	BDI = 'BDI',
	BEL = 'BEL',
	BEN = 'BEN',
	BES = 'BES',
	BFA = 'BFA',
	BGD = 'BGD',
	BGR = 'BGR',
	BHR = 'BHR',
	BHS = 'BHS',
	BIH = 'BIH',
	BLM = 'BLM',
	BLR = 'BLR',
	BLZ = 'BLZ',
	BMU = 'BMU',
	BOL = 'BOL',
	BRA = 'BRA',
	BRB = 'BRB',
	BRN = 'BRN',
	BTN = 'BTN',
	BVT = 'BVT',
	BWA = 'BWA',
	CAF = 'CAF',
	CAN = 'CAN',
	CCK = 'CCK',
	CHE = 'CHE',
	CHL = 'CHL',
	CHN = 'CHN',
	CIV = 'CIV',
	CMR = 'CMR',
	COD = 'COD',
	COG = 'COG',
	COK = 'COK',
	COL = 'COL',
	COM = 'COM',
	CPV = 'CPV',
	CRI = 'CRI',
	CUB = 'CUB',
	CUW = 'CUW',
	CXR = 'CXR',
	CYM = 'CYM',
	CYP = 'CYP',
	CZE = 'CZE',
	DEU = 'DEU',
	DJI = 'DJI',
	DMA = 'DMA',
	DNK = 'DNK',
	DOM = 'DOM',
	DZA = 'DZA',
	ECU = 'ECU',
	EGY = 'EGY',
	ERI = 'ERI',
	ESH = 'ESH',
	ESP = 'ESP',
	EST = 'EST',
	ETH = 'ETH',
	FIN = 'FIN',
	FJI = 'FJI',
	FLK = 'FLK',
	FRA = 'FRA',
	FRO = 'FRO',
	FSM = 'FSM',
	GAB = 'GAB',
	GBR = 'GBR',
	GEO = 'GEO',
	GGY = 'GGY',
	GHA = 'GHA',
	GIB = 'GIB',
	GIN = 'GIN',
	GLP = 'GLP',
	GMB = 'GMB',
	GNB = 'GNB',
	GNQ = 'GNQ',
	GRC = 'GRC',
	GRD = 'GRD',
	GRL = 'GRL',
	GTM = 'GTM',
	GUF = 'GUF',
	GUM = 'GUM',
	GUY = 'GUY',
	HKG = 'HKG',
	HMD = 'HMD',
	HND = 'HND',
	HRV = 'HRV',
	HTI = 'HTI',
	HUN = 'HUN',
	IDN = 'IDN',
	IMN = 'IMN',
	IND = 'IND',
	IOT = 'IOT',
	IRL = 'IRL',
	IRN = 'IRN',
	IRQ = 'IRQ',
	ISL = 'ISL',
	ISR = 'ISR',
	ITA = 'ITA',
	JAM = 'JAM',
	JEY = 'JEY',
	JOR = 'JOR',
	JPN = 'JPN',
	KAZ = 'KAZ',
	KEN = 'KEN',
	KGZ = 'KGZ',
	KHM = 'KHM',
	KIR = 'KIR',
	KNA = 'KNA',
	KOR = 'KOR',
	KWT = 'KWT',
	LAO = 'LAO',
	LBN = 'LBN',
	LBR = 'LBR',
	LBY = 'LBY',
	LCA = 'LCA',
	LIE = 'LIE',
	LKA = 'LKA',
	LSO = 'LSO',
	LTU = 'LTU',
	LUX = 'LUX',
	LVA = 'LVA',
	MAC = 'MAC',
	MAF = 'MAF',
	MAR = 'MAR',
	MCO = 'MCO',
	MDA = 'MDA',
	MDG = 'MDG',
	MDV = 'MDV',
	MEX = 'MEX',
	MHL = 'MHL',
	MKD = 'MKD',
	MLI = 'MLI',
	MLT = 'MLT',
	MMR = 'MMR',
	MNE = 'MNE',
	MNG = 'MNG',
	MNP = 'MNP',
	MOZ = 'MOZ',
	MRT = 'MRT',
	MSR = 'MSR',
	MTQ = 'MTQ',
	MUS = 'MUS',
	MWI = 'MWI',
	MYS = 'MYS',
	MYT = 'MYT',
	NAM = 'NAM',
	NCL = 'NCL',
	NER = 'NER',
	NFK = 'NFK',
	NGA = 'NGA',
	NIC = 'NIC',
	NIU = 'NIU',
	NLD = 'NLD',
	NOR = 'NOR',
	NPL = 'NPL',
	NRU = 'NRU',
	NZL = 'NZL',
	OMN = 'OMN',
	PAK = 'PAK',
	PAN = 'PAN',
	PCN = 'PCN',
	PER = 'PER',
	PHL = 'PHL',
	PLW = 'PLW',
	PNG = 'PNG',
	POL = 'POL',
	PRI = 'PRI',
	PRK = 'PRK',
	PRT = 'PRT',
	PRY = 'PRY',
	PSE = 'PSE',
	PYF = 'PYF',
	QAT = 'QAT',
	REU = 'REU',
	ROU = 'ROU',
	RUS = 'RUS',
	RWA = 'RWA',
	SAU = 'SAU',
	SDN = 'SDN',
	SEN = 'SEN',
	SGP = 'SGP',
	SGS = 'SGS',
	SHN = 'SHN',
	SJM = 'SJM',
	SLB = 'SLB',
	SLE = 'SLE',
	SLV = 'SLV',
	SMR = 'SMR',
	SOM = 'SOM',
	SPM = 'SPM',
	SRB = 'SRB',
	SSD = 'SSD',
	STP = 'STP',
	SUR = 'SUR',
	SVK = 'SVK',
	SVN = 'SVN',
	SWE = 'SWE',
	SWZ = 'SWZ',
	SXM = 'SXM',
	SYC = 'SYC',
	SYR = 'SYR',
	TCA = 'TCA',
	TCD = 'TCD',
	TGO = 'TGO',
	THA = 'THA',
	TJK = 'TJK',
	TKL = 'TKL',
	TKM = 'TKM',
	TLS = 'TLS',
	TON = 'TON',
	TTO = 'TTO',
	TUN = 'TUN',
	TUR = 'TUR',
	TUV = 'TUV',
	TWN = 'TWN',
	TZA = 'TZA',
	UGA = 'UGA',
	UKR = 'UKR',
	UMI = 'UMI',
	URY = 'URY',
	USA = 'USA',
	UZB = 'UZB',
	VAT = 'VAT',
	VCT = 'VCT',
	VEN = 'VEN',
	VGB = 'VGB',
	VIR = 'VIR',
	VNM = 'VNM',
	VUT = 'VUT',
	WLF = 'WLF',
	WSM = 'WSM',
	YEM = 'YEM',
	ZAF = 'ZAF',
	ZMB = 'ZMB',
	ZWE = 'ZWE'
}

export type CreditRequestMonthlyIncomeInformation = {
	__typename?: 'CreditRequestMonthlyIncomeInformation';
	businessSales?: Maybe<Money>;
	familyContributionsIncome?: Maybe<Money>;
	otherSourcesIncome?: Maybe<Money>;
	otherSourcesIncomeDetail?: Maybe<Scalars['String']['output']>;
	salary?: Maybe<Money>;
	totalIncome?: Maybe<Money>;
};

export type CreditRequestValueOfAssets = {
	__typename?: 'CreditRequestValueOfAssets';
	carsValue?: Maybe<Money>;
	equipmentDetail?: Maybe<Scalars['String']['output']>;
	equipmentValue?: Maybe<Money>;
	homeValue?: Maybe<Money>;
	landValue?: Maybe<Money>;
	savings?: Maybe<Money>;
	totalValueOfAssets?: Maybe<Money>;
};

export enum CreditUse {
	EXPANDING_BUSINESS = 'EXPANDING_BUSINESS',
	FINCLU_VAN = 'FINCLU_VAN',
	HOUSING = 'HOUSING',
	OTHER = 'OTHER',
	STARTING_BUSINESS = 'STARTING_BUSINESS',
	VEHICLE = 'VEHICLE'
}

export enum HouseType {
	FAMILY = 'FAMILY',
	MORTGAGED = 'MORTGAGED',
	OWNED = 'OWNED',
	RENTED = 'RENTED'
}

/** A keyset page of :antifraud_analysis */
export type KeysetPageOfAntifraudAnalysis = {
	__typename?: 'KeysetPageOfAntifraudAnalysis';
	/** Total count on all pages */
	count?: Maybe<Scalars['Int']['output']>;
	/** The last keyset in the results */
	endKeyset?: Maybe<Scalars['String']['output']>;
	/** The records contained in the page */
	results?: Maybe<Array<AntifraudAnalysis>>;
	/** The first keyset in the results */
	startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :microcredit_request */
export type KeysetPageOfMicrocreditRequest = {
	__typename?: 'KeysetPageOfMicrocreditRequest';
	/** Total count on all pages */
	count?: Maybe<Scalars['Int']['output']>;
	/** The last keyset in the results */
	endKeyset?: Maybe<Scalars['String']['output']>;
	/** The records contained in the page */
	results?: Maybe<Array<MicrocreditRequest>>;
	/** The first keyset in the results */
	startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :registry */
export type KeysetPageOfRegistry = {
	__typename?: 'KeysetPageOfRegistry';
	/** Total count on all pages */
	count?: Maybe<Scalars['Int']['output']>;
	/** The last keyset in the results */
	endKeyset?: Maybe<Scalars['String']['output']>;
	/** The records contained in the page */
	results?: Maybe<Array<Registry>>;
	/** The first keyset in the results */
	startKeyset?: Maybe<Scalars['String']['output']>;
};

export enum MaritalStatus {
	MARRIED = 'MARRIED',
	OTHER = 'OTHER',
	SINGLE = 'SINGLE'
}

export enum MexStates {
	AGU = 'AGU',
	BCN = 'BCN',
	BCS = 'BCS',
	CAM = 'CAM',
	CHH = 'CHH',
	CHP = 'CHP',
	CMX = 'CMX',
	COA = 'COA',
	COL = 'COL',
	DUR = 'DUR',
	GRO = 'GRO',
	GUA = 'GUA',
	HID = 'HID',
	JAL = 'JAL',
	MEX = 'MEX',
	MIC = 'MIC',
	MOR = 'MOR',
	NAY = 'NAY',
	NLE = 'NLE',
	OAX = 'OAX',
	PUE = 'PUE',
	QUE = 'QUE',
	ROO = 'ROO',
	SIN = 'SIN',
	SLP = 'SLP',
	SON = 'SON',
	TAB = 'TAB',
	TAM = 'TAM',
	TLA = 'TLA',
	VER = 'VER',
	YUC = 'YUC',
	ZAC = 'ZAC'
}

export type MicrocreditRequest = {
	__typename?: 'MicrocreditRequest';
	activityInformation?: Maybe<MicrocreditRequestActivityInformation>;
	clientId: Scalars['ID']['output'];
	creditDetails?: Maybe<MicrocreditRequestCreditDetails>;
	email: Scalars['String']['output'];
	firstLastName?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	insertedAt: Scalars['DateTime']['output'];
	monthlyBusinessExpenses?: Maybe<MicrocreditRequestMonthlyBusinessExpenses>;
	monthlyHouseExpenses?: Maybe<MicrocreditRequestMonthlyHomeExpenses>;
	monthlyIncomeInformation?: Maybe<CreditRequestMonthlyIncomeInformation>;
	names?: Maybe<Scalars['String']['output']>;
	personalInformation?: Maybe<MicrocreditRequestPersonalInformation>;
	phoneNumber?: Maybe<Scalars['String']['output']>;
	preliminarPaymentCapacity?: Maybe<Money>;
	secondLastName?: Maybe<Scalars['String']['output']>;
	status: MicrocreditRequestStatus;
	updatedAt: Scalars['DateTime']['output'];
	valueOfAssets?: Maybe<CreditRequestValueOfAssets>;
};

export type MicrocreditRequestActivityInformation = {
	__typename?: 'MicrocreditRequestActivityInformation';
	activityType: ActivityType;
	activityTypeDetail?: Maybe<Scalars['String']['output']>;
	operatingTimeRange?: Maybe<OperatingTimeRange>;
	startDate?: Maybe<Scalars['Date']['output']>;
};

export type MicrocreditRequestActivityInformationInput = {
	activityType?: InputMaybe<ActivityType>;
	activityTypeDetail?: InputMaybe<Scalars['String']['input']>;
	startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type MicrocreditRequestCreditDetails = {
	__typename?: 'MicrocreditRequestCreditDetails';
	amountRequested: Money;
	creditUse: CreditUse;
	creditUseDetail?: Maybe<Scalars['String']['output']>;
	expectedAdditionalIncome: Money;
};

export type MicrocreditRequestCreditDetailsInput = {
	amountRequested?: InputMaybe<MoneyInput>;
	creditUse?: InputMaybe<CreditUse>;
	creditUseDetail?: InputMaybe<Scalars['String']['input']>;
	expectedAdditionalIncome?: InputMaybe<MoneyInput>;
};

export type MicrocreditRequestFilterClientId = {
	eq?: InputMaybe<Scalars['ID']['input']>;
	greaterThan?: InputMaybe<Scalars['ID']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	in?: InputMaybe<Array<Scalars['ID']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['ID']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type MicrocreditRequestFilterEmail = {
	eq?: InputMaybe<Scalars['String']['input']>;
	greaterThan?: InputMaybe<Scalars['String']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	in?: InputMaybe<Array<Scalars['String']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['String']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	notEq?: InputMaybe<Scalars['String']['input']>;
};

export type MicrocreditRequestFilterFirstLastName = {
	eq?: InputMaybe<Scalars['String']['input']>;
	greaterThan?: InputMaybe<Scalars['String']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	ilike?: InputMaybe<Scalars['String']['input']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['String']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	like?: InputMaybe<Scalars['String']['input']>;
	notEq?: InputMaybe<Scalars['String']['input']>;
};

export type MicrocreditRequestFilterId = {
	eq?: InputMaybe<Scalars['ID']['input']>;
	greaterThan?: InputMaybe<Scalars['ID']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	in?: InputMaybe<Array<Scalars['ID']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['ID']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type MicrocreditRequestFilterInput = {
	and?: InputMaybe<Array<MicrocreditRequestFilterInput>>;
	clientId?: InputMaybe<MicrocreditRequestFilterClientId>;
	email?: InputMaybe<MicrocreditRequestFilterEmail>;
	firstLastName?: InputMaybe<MicrocreditRequestFilterFirstLastName>;
	id?: InputMaybe<MicrocreditRequestFilterId>;
	insertedAt?: InputMaybe<MicrocreditRequestFilterInsertedAt>;
	names?: InputMaybe<MicrocreditRequestFilterNames>;
	not?: InputMaybe<Array<MicrocreditRequestFilterInput>>;
	or?: InputMaybe<Array<MicrocreditRequestFilterInput>>;
	phoneNumber?: InputMaybe<MicrocreditRequestFilterPhoneNumber>;
	secondLastName?: InputMaybe<MicrocreditRequestFilterSecondLastName>;
	status?: InputMaybe<MicrocreditRequestFilterStatus>;
	updatedAt?: InputMaybe<MicrocreditRequestFilterUpdatedAt>;
};

export type MicrocreditRequestFilterInsertedAt = {
	eq?: InputMaybe<Scalars['DateTime']['input']>;
	greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
	in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['DateTime']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
	notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MicrocreditRequestFilterNames = {
	eq?: InputMaybe<Scalars['String']['input']>;
	greaterThan?: InputMaybe<Scalars['String']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	ilike?: InputMaybe<Scalars['String']['input']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['String']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	like?: InputMaybe<Scalars['String']['input']>;
	notEq?: InputMaybe<Scalars['String']['input']>;
};

export type MicrocreditRequestFilterPhoneNumber = {
	eq?: InputMaybe<Scalars['String']['input']>;
	greaterThan?: InputMaybe<Scalars['String']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	ilike?: InputMaybe<Scalars['String']['input']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['String']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	like?: InputMaybe<Scalars['String']['input']>;
	notEq?: InputMaybe<Scalars['String']['input']>;
};

export type MicrocreditRequestFilterSecondLastName = {
	eq?: InputMaybe<Scalars['String']['input']>;
	greaterThan?: InputMaybe<Scalars['String']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	ilike?: InputMaybe<Scalars['String']['input']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['String']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	like?: InputMaybe<Scalars['String']['input']>;
	notEq?: InputMaybe<Scalars['String']['input']>;
};

export type MicrocreditRequestFilterStatus = {
	eq?: InputMaybe<MicrocreditRequestStatus>;
	greaterThan?: InputMaybe<MicrocreditRequestStatus>;
	greaterThanOrEqual?: InputMaybe<MicrocreditRequestStatus>;
	in?: InputMaybe<Array<MicrocreditRequestStatus>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<MicrocreditRequestStatus>;
	lessThanOrEqual?: InputMaybe<MicrocreditRequestStatus>;
	notEq?: InputMaybe<MicrocreditRequestStatus>;
};

export type MicrocreditRequestFilterUpdatedAt = {
	eq?: InputMaybe<Scalars['DateTime']['input']>;
	greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
	in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['DateTime']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
	notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MicrocreditRequestMonthlyBusinessExpenses = {
	__typename?: 'MicrocreditRequestMonthlyBusinessExpenses';
	electricBill?: Maybe<Money>;
	equipmentMaintenance?: Maybe<Money>;
	gas?: Maybe<Money>;
	inputsPurchase?: Maybe<Money>;
	internetBill?: Maybe<Money>;
	rent?: Maybe<Money>;
	salaries?: Maybe<Money>;
	totalBusinessExpenses?: Maybe<Money>;
};

export type MicrocreditRequestMonthlyBusinessExpensesInput = {
	electricBill?: InputMaybe<MoneyInput>;
	equipmentMaintenance?: InputMaybe<MoneyInput>;
	gas?: InputMaybe<MoneyInput>;
	inputsPurchase?: InputMaybe<MoneyInput>;
	internetBill?: InputMaybe<MoneyInput>;
	rent?: InputMaybe<MoneyInput>;
	salaries?: InputMaybe<MoneyInput>;
};

export type MicrocreditRequestMonthlyHomeExpenses = {
	__typename?: 'MicrocreditRequestMonthlyHomeExpenses';
	electricBill?: Maybe<Money>;
	familyExpenses?: Maybe<Money>;
	groceries?: Maybe<Money>;
	internetBill?: Maybe<Money>;
	rent?: Maybe<Money>;
	totalHouseExpenses?: Maybe<Money>;
	tuitions?: Maybe<Money>;
	waterBill?: Maybe<Money>;
};

export type MicrocreditRequestMonthlyHouseExpensesInput = {
	electricBill?: InputMaybe<MoneyInput>;
	familyExpenses?: InputMaybe<MoneyInput>;
	groceries?: InputMaybe<MoneyInput>;
	internetBill?: InputMaybe<MoneyInput>;
	rent?: InputMaybe<MoneyInput>;
	tuitions?: InputMaybe<MoneyInput>;
	waterBill?: InputMaybe<MoneyInput>;
};

export type MicrocreditRequestMonthlyIncomeInformationInput = {
	businessSales?: InputMaybe<MoneyInput>;
	familyContributionsIncome?: InputMaybe<MoneyInput>;
	otherSourcesIncome?: InputMaybe<MoneyInput>;
	otherSourcesIncomeDetail?: InputMaybe<Scalars['String']['input']>;
	salary?: InputMaybe<MoneyInput>;
};

export type MicrocreditRequestPersonalInformation = {
	__typename?: 'MicrocreditRequestPersonalInformation';
	childDependants?: Maybe<Scalars['Int']['output']>;
	currentTotalDebt?: Maybe<Money>;
	houseType: HouseType;
	livesWithWhichFamilyMember?: Maybe<Scalars['String']['output']>;
	monthlyPaymentToCredits?: Maybe<Money>;
	nameOfFamilyMemberWithFincluyenteCredit?: Maybe<Scalars['String']['output']>;
	otherFamilyDependants?: Maybe<Scalars['Int']['output']>;
	otherFamilyDependantsExplanation?: Maybe<Scalars['String']['output']>;
	transportationMethod: TransportationMethod;
};

export type MicrocreditRequestPersonalInformationInput = {
	childDependants?: InputMaybe<Scalars['Int']['input']>;
	currentTotalDebt?: InputMaybe<MoneyInput>;
	houseType?: InputMaybe<HouseType>;
	livesWithWhichFamilyMember?: InputMaybe<Scalars['String']['input']>;
	monthlyPaymentToCredits?: InputMaybe<MoneyInput>;
	nameOfFamilyMemberWithFincluyenteCredit?: InputMaybe<Scalars['String']['input']>;
	otherFamilyDependants?: InputMaybe<Scalars['Int']['input']>;
	otherFamilyDependantsExplanation?: InputMaybe<Scalars['String']['input']>;
	transportationMethod?: InputMaybe<TransportationMethod>;
};

export enum MicrocreditRequestSortField {
	CLIENT_ID = 'CLIENT_ID',
	EMAIL = 'EMAIL',
	FIRST_LAST_NAME = 'FIRST_LAST_NAME',
	ID = 'ID',
	INSERTED_AT = 'INSERTED_AT',
	NAMES = 'NAMES',
	PHONE_NUMBER = 'PHONE_NUMBER',
	SECOND_LAST_NAME = 'SECOND_LAST_NAME',
	STATUS = 'STATUS',
	UPDATED_AT = 'UPDATED_AT'
}

export type MicrocreditRequestSortInput = {
	field: MicrocreditRequestSortField;
	order?: InputMaybe<SortOrder>;
};

export enum MicrocreditRequestStatus {
	ACTIVITY_INFORMATION_REGISTERED = 'ACTIVITY_INFORMATION_REGISTERED',
	COMPLETED = 'COMPLETED',
	CREATED = 'CREATED',
	CREDIT_DETAILS_REGISTERED = 'CREDIT_DETAILS_REGISTERED',
	MONTHLY_BUSINESS_EXPENSES_REGISTERED = 'MONTHLY_BUSINESS_EXPENSES_REGISTERED',
	MONTHLY_HOUSE_EXPENSES_REGISTERED = 'MONTHLY_HOUSE_EXPENSES_REGISTERED',
	MONTHLY_INCOME_INFORMATION_REGISTERED = 'MONTHLY_INCOME_INFORMATION_REGISTERED',
	PERSONAL_INFORMATION_REGISTERED = 'PERSONAL_INFORMATION_REGISTERED'
}

export type MicrocreditRequestValueOfAssetsInput = {
	carsValue?: InputMaybe<MoneyInput>;
	equipmentDetail?: InputMaybe<Scalars['String']['input']>;
	equipmentValue?: InputMaybe<MoneyInput>;
	homeValue?: InputMaybe<MoneyInput>;
	landValue?: InputMaybe<MoneyInput>;
	savings?: InputMaybe<MoneyInput>;
};

export type Money = {
	__typename?: 'Money';
	amount: Scalars['Decimal']['output'];
	currency: Scalars['String']['output'];
};

export type MoneyInput = {
	amount: Scalars['Decimal']['input'];
	currency: Scalars['String']['input'];
};

/** An error generated by a failed mutation */
export type MutationError = {
	__typename?: 'MutationError';
	/** An error code for the given error */
	code?: Maybe<Scalars['String']['output']>;
	/** The field or fields that produced the error */
	fields?: Maybe<Array<Scalars['String']['output']>>;
	/** The human readable error message */
	message?: Maybe<Scalars['String']['output']>;
	/** A shorter error message, with vars not replaced */
	shortMessage?: Maybe<Scalars['String']['output']>;
	/** Replacements for the short message */
	vars?: Maybe<Scalars['Json']['output']>;
};

export enum Nationality {
	MEX = 'MEX'
}

export enum OnboardingStatus {
	APPROVED = 'APPROVED',
	CORRECTIONS_REQUESTED = 'CORRECTIONS_REQUESTED',
	IN_PROCESS = 'IN_PROCESS',
	PENDING_REVIEW = 'PENDING_REVIEW',
	REJECTED = 'REJECTED'
}

export type OnboardingStep = {
	__typename?: 'OnboardingStep';
	displayName: Scalars['String']['output'];
	name: RegistryStepName;
	stepsCompleted: Scalars['Int']['output'];
	stepsCount: Scalars['Int']['output'];
};

export enum OperatingTimeRange {
	BETWEEN_SIXTH_AND_TENTH_YEAR = 'BETWEEN_SIXTH_AND_TENTH_YEAR',
	IN_FIFTH_YEAR = 'IN_FIFTH_YEAR',
	IN_FOURTH_YEAR = 'IN_FOURTH_YEAR',
	IN_SECOND_YEAR = 'IN_SECOND_YEAR',
	IN_THIRD_YEAR = 'IN_THIRD_YEAR',
	LESS_THAN_TWELVE_MONTHS = 'LESS_THAN_TWELVE_MONTHS',
	MORE_THAN_TEN_YEARS = 'MORE_THAN_TEN_YEARS'
}

export type RegisterBirthInformationInput = {
	birthInformation: RegistryBirthInformationInput;
};

/** The result of the :register_birth_information mutation */
export type RegisterBirthInformationResult = {
	__typename?: 'RegisterBirthInformationResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<Registry>;
};

export type RegisterLcActivityInformationInput = {
	activityInformation: MicrocreditRequestActivityInformationInput;
};

/** The result of the :register_lc_activity_information mutation */
export type RegisterLcActivityInformationResult = {
	__typename?: 'RegisterLcActivityInformationResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<MicrocreditRequest>;
};

export type RegisterLcCreditDetailsInput = {
	creditDetails: MicrocreditRequestCreditDetailsInput;
};

/** The result of the :register_lc_credit_details mutation */
export type RegisterLcCreditDetailsResult = {
	__typename?: 'RegisterLcCreditDetailsResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<MicrocreditRequest>;
};

export type RegisterLcMonthlyBusinessExpensesRegisteredInput = {
	monthlyBusinessExpenses: MicrocreditRequestMonthlyBusinessExpensesInput;
};

/** The result of the :register_lc_monthly_business_expenses_registered mutation */
export type RegisterLcMonthlyBusinessExpensesRegisteredResult = {
	__typename?: 'RegisterLcMonthlyBusinessExpensesRegisteredResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<MicrocreditRequest>;
};

export type RegisterLcMonthlyHouseExpensesInput = {
	monthlyHouseExpenses: MicrocreditRequestMonthlyHouseExpensesInput;
};

/** The result of the :register_lc_monthly_house_expenses mutation */
export type RegisterLcMonthlyHouseExpensesResult = {
	__typename?: 'RegisterLcMonthlyHouseExpensesResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<MicrocreditRequest>;
};

export type RegisterLcMonthlyIncomeInformationInput = {
	monthlyIncomeInformation: MicrocreditRequestMonthlyIncomeInformationInput;
};

/** The result of the :register_lc_monthly_income_information mutation */
export type RegisterLcMonthlyIncomeInformationResult = {
	__typename?: 'RegisterLcMonthlyIncomeInformationResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<MicrocreditRequest>;
};

export type RegisterLcPersonalInformationInput = {
	firstLastName: Scalars['String']['input'];
	names: Scalars['String']['input'];
	personalInformation: MicrocreditRequestPersonalInformationInput;
	secondLastName?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the :register_lc_personal_information mutation */
export type RegisterLcPersonalInformationResult = {
	__typename?: 'RegisterLcPersonalInformationResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<MicrocreditRequest>;
};

export type RegisterLcValueOfAssetsInput = {
	valueOfAssets: MicrocreditRequestValueOfAssetsInput;
};

/** The result of the :register_lc_value_of_assets mutation */
export type RegisterLcValueOfAssetsResult = {
	__typename?: 'RegisterLcValueOfAssetsResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<MicrocreditRequest>;
};

export type RegisterOfficialAddressInput = {
	officialAddress: RegistryOfficialAddressInput;
};

/** The result of the :register_official_address mutation */
export type RegisterOfficialAddressResult = {
	__typename?: 'RegisterOfficialAddressResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<Registry>;
};

/** The result of the :register_openfin_client mutation */
export type RegisterOpenfinClientResult = {
	__typename?: 'RegisterOpenfinClientResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<User>;
};

export type RegisterPersonalInformationInput = {
	personalInformation: RegistryPersonalInformationInput;
};

export type RegisterTaxInformationInput = {
	taxInformation: RegistryTaxInformationInput;
};

/** The result of the :register_tax_information mutation */
export type RegisterTaxInformationResult = {
	__typename?: 'RegisterTaxInformationResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<Registry>;
};

export type Registry = {
	__typename?: 'Registry';
	birthInformation?: Maybe<RegistryBirthInformation>;
	clientId: Scalars['ID']['output'];
	contactInformation?: Maybe<RegistryContactInformation>;
	corrections?: Maybe<Array<Correction>>;
	currentOnboardingStep: OnboardingStep;
	currentRegistryStep: RegistryStep;
	deliberation?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	insertedAt: Scalars['DateTime']['output'];
	officialAddress?: Maybe<RegistryOfficialAddress>;
	onboardingStatus: OnboardingStatus;
	onboardingStatusDisplayName: Scalars['String']['output'];
	personalInformation?: Maybe<RegistryPersonalInformation>;
	proofOfLife?: Maybe<RegistryProofOfLife>;
	status: RegistryStatus;
	statusDisplayName: Scalars['String']['output'];
	taxInformation?: Maybe<RegistryTaxInformation>;
	updatedAt: Scalars['DateTime']['output'];
};

export type RegistryBirthInformation = {
	__typename?: 'RegistryBirthInformation';
	countryOfBirth: Country;
	dateOfBirth: Scalars['Date']['output'];
	nationality: Nationality;
	stateOfBirth?: Maybe<MexStates>;
};

export type RegistryBirthInformationInput = {
	countryOfBirth?: InputMaybe<Country>;
	dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
	nationality?: InputMaybe<Nationality>;
	stateOfBirth?: InputMaybe<MexStates>;
};

export type RegistryContactInformation = {
	__typename?: 'RegistryContactInformation';
	email: Scalars['String']['output'];
	phoneNumber?: Maybe<Scalars['String']['output']>;
};

export enum RegistryCorrectionField {
	BETWEEN_STREETS_ONE = 'BETWEEN_STREETS_ONE',
	BETWEEN_STREETS_TWO = 'BETWEEN_STREETS_TWO',
	CITY = 'CITY',
	CLABE = 'CLABE',
	COLONY = 'COLONY',
	COUNTRY_OF_BIRTH = 'COUNTRY_OF_BIRTH',
	CURP = 'CURP',
	DATE_OF_BIRTH = 'DATE_OF_BIRTH',
	EXTERNAL_NUMBER = 'EXTERNAL_NUMBER',
	E_SIGNATURE_SERIAL_NUMBER = 'E_SIGNATURE_SERIAL_NUMBER',
	FACEBOOK_PROFILE_URI = 'FACEBOOK_PROFILE_URI',
	FIRST_LAST_NAME = 'FIRST_LAST_NAME',
	HAS_CHILDREN = 'HAS_CHILDREN',
	INE_BACK = 'INE_BACK',
	INE_FRONT = 'INE_FRONT',
	INTERNAL_NUMBER = 'INTERNAL_NUMBER',
	MARITAL_STATUS = 'MARITAL_STATUS',
	MUNICIPALITY_OR_DELEGATION = 'MUNICIPALITY_OR_DELEGATION',
	NAMES = 'NAMES',
	NATIONALITY = 'NATIONALITY',
	POSTAL_CODE = 'POSTAL_CODE',
	PROOF_OF_ADDRESS = 'PROOF_OF_ADDRESS',
	RELATION_WITH_ADDRESS_HOLDER = 'RELATION_WITH_ADDRESS_HOLDER',
	RFC = 'RFC',
	SECOND_LAST_NAME = 'SECOND_LAST_NAME',
	SELFIE = 'SELFIE',
	STATE = 'STATE',
	STATE_OF_BIRTH = 'STATE_OF_BIRTH',
	STREET = 'STREET',
	TAX_REGIME_CODE = 'TAX_REGIME_CODE',
	TAX_STATUS_CERTIFICATE = 'TAX_STATUS_CERTIFICATE'
}

export enum RegistryCorrectionSection {
	BIRTH_INFORMATION = 'BIRTH_INFORMATION',
	OFFICIAL_ADDRESS = 'OFFICIAL_ADDRESS',
	PERSONAL_INFORMATION = 'PERSONAL_INFORMATION',
	PROOF_OF_LIFE = 'PROOF_OF_LIFE',
	TAX_INFORMATION = 'TAX_INFORMATION'
}

export type RegistryCorrectionsInput = {
	field?: InputMaybe<RegistryCorrectionField>;
	section?: InputMaybe<RegistryCorrectionSection>;
};

export type RegistryFilterClientId = {
	eq?: InputMaybe<Scalars['ID']['input']>;
	greaterThan?: InputMaybe<Scalars['ID']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	in?: InputMaybe<Array<Scalars['ID']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['ID']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type RegistryFilterDeliberation = {
	eq?: InputMaybe<Scalars['String']['input']>;
	greaterThan?: InputMaybe<Scalars['String']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	ilike?: InputMaybe<Scalars['String']['input']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['String']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	like?: InputMaybe<Scalars['String']['input']>;
	notEq?: InputMaybe<Scalars['String']['input']>;
};

export type RegistryFilterId = {
	eq?: InputMaybe<Scalars['ID']['input']>;
	greaterThan?: InputMaybe<Scalars['ID']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	in?: InputMaybe<Array<Scalars['ID']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['ID']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type RegistryFilterInput = {
	and?: InputMaybe<Array<RegistryFilterInput>>;
	clientId?: InputMaybe<RegistryFilterClientId>;
	deliberation?: InputMaybe<RegistryFilterDeliberation>;
	id?: InputMaybe<RegistryFilterId>;
	insertedAt?: InputMaybe<RegistryFilterInsertedAt>;
	not?: InputMaybe<Array<RegistryFilterInput>>;
	or?: InputMaybe<Array<RegistryFilterInput>>;
	status?: InputMaybe<RegistryFilterStatus>;
	updatedAt?: InputMaybe<RegistryFilterUpdatedAt>;
};

export type RegistryFilterInsertedAt = {
	eq?: InputMaybe<Scalars['DateTime']['input']>;
	greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
	in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['DateTime']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
	notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RegistryFilterStatus = {
	eq?: InputMaybe<RegistryStatus>;
	greaterThan?: InputMaybe<RegistryStatus>;
	greaterThanOrEqual?: InputMaybe<RegistryStatus>;
	in?: InputMaybe<Array<RegistryStatus>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<RegistryStatus>;
	lessThanOrEqual?: InputMaybe<RegistryStatus>;
	notEq?: InputMaybe<RegistryStatus>;
};

export type RegistryFilterUpdatedAt = {
	eq?: InputMaybe<Scalars['DateTime']['input']>;
	greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
	in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['DateTime']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
	notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RegistryOfficialAddress = {
	__typename?: 'RegistryOfficialAddress';
	betweenStreetsOne?: Maybe<Scalars['String']['output']>;
	betweenStreetsTwo?: Maybe<Scalars['String']['output']>;
	city?: Maybe<Scalars['String']['output']>;
	colony?: Maybe<Scalars['String']['output']>;
	externalNumber?: Maybe<Scalars['String']['output']>;
	internalNumber?: Maybe<Scalars['String']['output']>;
	municipalityOrDelegation?: Maybe<Scalars['String']['output']>;
	postalCode?: Maybe<Scalars['String']['output']>;
	proofOfAddress?: Maybe<S3File>;
	relationWithAddressHolder?: Maybe<RelationWithAddressOwner>;
	state?: Maybe<MexStates>;
	street?: Maybe<Scalars['String']['output']>;
};

export type RegistryOfficialAddressInput = {
	betweenStreetsOne?: InputMaybe<Scalars['String']['input']>;
	betweenStreetsTwo?: InputMaybe<Scalars['String']['input']>;
	city?: InputMaybe<Scalars['String']['input']>;
	colony?: InputMaybe<Scalars['String']['input']>;
	externalNumber?: InputMaybe<Scalars['String']['input']>;
	internalNumber?: InputMaybe<Scalars['String']['input']>;
	municipalityOrDelegation?: InputMaybe<Scalars['String']['input']>;
	postalCode?: InputMaybe<Scalars['String']['input']>;
	proofOfAddress?: InputMaybe<RegistryOfficialAddressProofOfAddressInput>;
	relationWithAddressHolder?: InputMaybe<RelationWithAddressOwner>;
	state?: InputMaybe<MexStates>;
	street?: InputMaybe<Scalars['String']['input']>;
};

export type RegistryOfficialAddressProofOfAddressInput = {
	awsRegion?: InputMaybe<Scalars['String']['input']>;
	s3Bucket?: InputMaybe<Scalars['String']['input']>;
	s3Key?: InputMaybe<Scalars['String']['input']>;
};

export type RegistryPersonalInformation = {
	__typename?: 'RegistryPersonalInformation';
	curp: Scalars['String']['output'];
	facebookProfileUri?: Maybe<Scalars['String']['output']>;
	firstLastName: Scalars['String']['output'];
	hasChildren: Scalars['Boolean']['output'];
	maritalStatus: MaritalStatus;
	names: Scalars['String']['output'];
	secondLastName?: Maybe<Scalars['String']['output']>;
};

export type RegistryPersonalInformationInput = {
	curp?: InputMaybe<Scalars['String']['input']>;
	facebookProfileUri?: InputMaybe<Scalars['String']['input']>;
	firstLastName?: InputMaybe<Scalars['String']['input']>;
	hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
	maritalStatus?: InputMaybe<MaritalStatus>;
	names?: InputMaybe<Scalars['String']['input']>;
	secondLastName?: InputMaybe<Scalars['String']['input']>;
};

export type RegistryProofOfLife = {
	__typename?: 'RegistryProofOfLife';
	ineBack?: Maybe<S3File>;
	ineFront?: Maybe<S3File>;
	selfie?: Maybe<S3File>;
};

export type RegistryProofOfLifeIneBackInput = {
	awsRegion?: InputMaybe<Scalars['String']['input']>;
	s3Bucket?: InputMaybe<Scalars['String']['input']>;
	s3Key?: InputMaybe<Scalars['String']['input']>;
};

export type RegistryProofOfLifeIneFrontInput = {
	awsRegion?: InputMaybe<Scalars['String']['input']>;
	s3Bucket?: InputMaybe<Scalars['String']['input']>;
	s3Key?: InputMaybe<Scalars['String']['input']>;
};

export type RegistryProofOfLifeInput = {
	ineBack?: InputMaybe<RegistryProofOfLifeIneBackInput>;
	ineFront?: InputMaybe<RegistryProofOfLifeIneFrontInput>;
	selfie?: InputMaybe<RegistryProofOfLifeSelfieInput>;
};

export type RegistryProofOfLifeSelfieInput = {
	awsRegion?: InputMaybe<Scalars['String']['input']>;
	s3Bucket?: InputMaybe<Scalars['String']['input']>;
	s3Key?: InputMaybe<Scalars['String']['input']>;
};

export enum RegistrySortField {
	CLIENT_ID = 'CLIENT_ID',
	DELIBERATION = 'DELIBERATION',
	ID = 'ID',
	INSERTED_AT = 'INSERTED_AT',
	STATUS = 'STATUS',
	UPDATED_AT = 'UPDATED_AT'
}

export type RegistrySortInput = {
	field: RegistrySortField;
	order?: InputMaybe<SortOrder>;
};

export enum RegistryStatus {
	APPROVED = 'APPROVED',
	BIRTH_INFORMATION_REGISTERED = 'BIRTH_INFORMATION_REGISTERED',
	COMPLETED = 'COMPLETED',
	CORRECTIONS_REQUESTED = 'CORRECTIONS_REQUESTED',
	CREATED = 'CREATED',
	OFFICIAL_ADDRESS_REGISTERED = 'OFFICIAL_ADDRESS_REGISTERED',
	PERSONAL_INFORMATION_REGISTERED = 'PERSONAL_INFORMATION_REGISTERED',
	REJECTED = 'REJECTED',
	TAX_INFORMATION_REGISTERED = 'TAX_INFORMATION_REGISTERED'
}

export type RegistryStep = {
	__typename?: 'RegistryStep';
	displayName: Scalars['String']['output'];
	name: RegistryStepName;
	stepsCompleted: Scalars['Int']['output'];
	stepsCount: Scalars['Int']['output'];
};

export enum RegistryStepName {
	APPROVAL = 'APPROVAL',
	BIRTH_INFORMATION = 'BIRTH_INFORMATION',
	COMPLETED = 'COMPLETED',
	CORRECTIONS_REQUESTED = 'CORRECTIONS_REQUESTED',
	CREATED = 'CREATED',
	OFFICIAL_ADDRESS = 'OFFICIAL_ADDRESS',
	PERSONAL_INFORMATION = 'PERSONAL_INFORMATION',
	TAX_INFORMATION = 'TAX_INFORMATION'
}

export type RegistryTaxInformation = {
	__typename?: 'RegistryTaxInformation';
	clabe?: Maybe<Scalars['String']['output']>;
	clabeBankName?: Maybe<Scalars['String']['output']>;
	eSignatureSerialNumber?: Maybe<Scalars['String']['output']>;
	rfc?: Maybe<Scalars['String']['output']>;
	taxRegimeCode?: Maybe<TaxRegimeCode>;
	taxStatusCertificate?: Maybe<S3File>;
};

export type RegistryTaxInformationInput = {
	clabe?: InputMaybe<Scalars['String']['input']>;
	eSignatureSerialNumber?: InputMaybe<Scalars['String']['input']>;
	rfc?: InputMaybe<Scalars['String']['input']>;
	taxRegimeCode?: InputMaybe<TaxRegimeCode>;
	taxStatusCertificate?: InputMaybe<RegistryTaxInformationTaxStatusCertificateInput>;
};

export type RegistryTaxInformationTaxStatusCertificateInput = {
	awsRegion?: InputMaybe<Scalars['String']['input']>;
	s3Bucket?: InputMaybe<Scalars['String']['input']>;
	s3Key?: InputMaybe<Scalars['String']['input']>;
};

export type RejectRegistryInput = {
	deliberation: Scalars['String']['input'];
};

/** The result of the :reject_registry mutation */
export type RejectRegistryResult = {
	__typename?: 'RejectRegistryResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<Registry>;
};

export enum RelationWithAddressOwner {
	CHILD = 'CHILD',
	FAMILY = 'FAMILY',
	MYSELF = 'MYSELF',
	OTHER = 'OTHER',
	PARENT = 'PARENT',
	SIBLING = 'SIBLING',
	TENANT = 'TENANT'
}

export type RequestRegistryCorrectionsInput = {
	corrections: Array<RegistryCorrectionsInput>;
};

/** The result of the :request_registry_corrections mutation */
export type RequestRegistryCorrectionsResult = {
	__typename?: 'RequestRegistryCorrectionsResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<Registry>;
};

export type RootMutationType = {
	__typename?: 'RootMutationType';
	applyAntifraudAnalysis: ApplyAntifraudAnalysisResult;
	approveRegistry: ApproveRegistryResult;
	completeProofOfLife: CompleteProofOfLifeResult;
	registerBirthInformation: RegisterBirthInformationResult;
	registerLcActivityInformation: RegisterLcActivityInformationResult;
	registerLcCreditDetails: RegisterLcCreditDetailsResult;
	registerLcMonthlyBusinessExpensesRegistered: RegisterLcMonthlyBusinessExpensesRegisteredResult;
	registerLcMonthlyHouseExpenses: RegisterLcMonthlyHouseExpensesResult;
	registerLcMonthlyIncomeInformation: RegisterLcMonthlyIncomeInformationResult;
	registerLcPersonalInformation: RegisterLcPersonalInformationResult;
	registerLcValueOfAssets: RegisterLcValueOfAssetsResult;
	registerOfficialAddress: RegisterOfficialAddressResult;
	registerOpenfinClient: RegisterOpenfinClientResult;
	registerPersonalInformation: Registry;
	registerTaxInformation: RegisterTaxInformationResult;
	rejectRegistry: RejectRegistryResult;
	requestRegistryCorrections: RequestRegistryCorrectionsResult;
	solveRegistryCorrections: SolveRegistryCorrectionsResult;
	updateTrullyInformation: UpdateTrullyInformationResult;
	uploadIneBack: S3PresignedPost;
	uploadIneFront: S3PresignedPost;
	uploadProofOfAddress: S3PresignedPost;
	uploadSelfie: S3PresignedPost;
	uploadTaxStatusCertificate: S3PresignedPost;
};

export type RootMutationTypeApplyAntifraudAnalysisArgs = {
	id: Scalars['ID']['input'];
};

export type RootMutationTypeApproveRegistryArgs = {
	id: Scalars['ID']['input'];
	input: ApproveRegistryInput;
};

export type RootMutationTypeCompleteProofOfLifeArgs = {
	id: Scalars['ID']['input'];
};

export type RootMutationTypeRegisterBirthInformationArgs = {
	id: Scalars['ID']['input'];
	input: RegisterBirthInformationInput;
};

export type RootMutationTypeRegisterLcActivityInformationArgs = {
	id: Scalars['ID']['input'];
	input: RegisterLcActivityInformationInput;
};

export type RootMutationTypeRegisterLcCreditDetailsArgs = {
	id: Scalars['ID']['input'];
	input: RegisterLcCreditDetailsInput;
};

export type RootMutationTypeRegisterLcMonthlyBusinessExpensesRegisteredArgs = {
	id: Scalars['ID']['input'];
	input: RegisterLcMonthlyBusinessExpensesRegisteredInput;
};

export type RootMutationTypeRegisterLcMonthlyHouseExpensesArgs = {
	id: Scalars['ID']['input'];
	input: RegisterLcMonthlyHouseExpensesInput;
};

export type RootMutationTypeRegisterLcMonthlyIncomeInformationArgs = {
	id: Scalars['ID']['input'];
	input: RegisterLcMonthlyIncomeInformationInput;
};

export type RootMutationTypeRegisterLcPersonalInformationArgs = {
	id: Scalars['ID']['input'];
	input: RegisterLcPersonalInformationInput;
};

export type RootMutationTypeRegisterLcValueOfAssetsArgs = {
	id: Scalars['ID']['input'];
	input: RegisterLcValueOfAssetsInput;
};

export type RootMutationTypeRegisterOfficialAddressArgs = {
	id: Scalars['ID']['input'];
	input: RegisterOfficialAddressInput;
};

export type RootMutationTypeRegisterOpenfinClientArgs = {
	id: Scalars['ID']['input'];
};

export type RootMutationTypeRegisterPersonalInformationArgs = {
	input?: InputMaybe<RegisterPersonalInformationInput>;
};

export type RootMutationTypeRegisterTaxInformationArgs = {
	id: Scalars['ID']['input'];
	input: RegisterTaxInformationInput;
};

export type RootMutationTypeRejectRegistryArgs = {
	id: Scalars['ID']['input'];
	input: RejectRegistryInput;
};

export type RootMutationTypeRequestRegistryCorrectionsArgs = {
	id: Scalars['ID']['input'];
	input: RequestRegistryCorrectionsInput;
};

export type RootMutationTypeSolveRegistryCorrectionsArgs = {
	id: Scalars['ID']['input'];
	input?: InputMaybe<SolveRegistryCorrectionsInput>;
};

export type RootMutationTypeUpdateTrullyInformationArgs = {
	id: Scalars['ID']['input'];
	input?: InputMaybe<UpdateTrullyInformationInput>;
};

export type RootMutationTypeUploadIneBackArgs = {
	input?: InputMaybe<UploadIneBackInput>;
};

export type RootMutationTypeUploadIneFrontArgs = {
	input?: InputMaybe<UploadIneFrontInput>;
};

export type RootMutationTypeUploadProofOfAddressArgs = {
	input?: InputMaybe<UploadProofOfAddressInput>;
};

export type RootMutationTypeUploadSelfieArgs = {
	input?: InputMaybe<UploadSelfieInput>;
};

export type RootMutationTypeUploadTaxStatusCertificateArgs = {
	input?: InputMaybe<UploadTaxStatusCertificateInput>;
};

export type RootQueryType = {
	__typename?: 'RootQueryType';
	getARegistry?: Maybe<Registry>;
	getAntifraudAnalysis?: Maybe<AntifraudAnalysis>;
	getMicrocreditRequest?: Maybe<MicrocreditRequest>;
	listAntifraudAnalyses?: Maybe<KeysetPageOfAntifraudAnalysis>;
	listFilteredRegistries?: Maybe<KeysetPageOfRegistry>;
	listMicrocreditRequests?: Maybe<KeysetPageOfMicrocreditRequest>;
	listOnboardingSteps?: Maybe<Array<Maybe<OnboardingStep>>>;
	listRegistrySteps?: Maybe<Array<Maybe<RegistryStep>>>;
	me?: Maybe<User>;
};

export type RootQueryTypeGetARegistryArgs = {
	filter?: InputMaybe<RegistryFilterInput>;
};

export type RootQueryTypeGetAntifraudAnalysisArgs = {
	clientId?: InputMaybe<Scalars['ID']['input']>;
	filter?: InputMaybe<AntifraudAnalysisFilterInput>;
};

export type RootQueryTypeGetMicrocreditRequestArgs = {
	filter?: InputMaybe<MicrocreditRequestFilterInput>;
	id?: InputMaybe<Scalars['ID']['input']>;
};

export type RootQueryTypeListAntifraudAnalysesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	filter?: InputMaybe<AntifraudAnalysisFilterInput>;
	first?: InputMaybe<Scalars['Int']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	sort?: InputMaybe<Array<InputMaybe<AntifraudAnalysisSortInput>>>;
};

export type RootQueryTypeListFilteredRegistriesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	filter?: InputMaybe<RegistryFilterInput>;
	first?: InputMaybe<Scalars['Int']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	sort?: InputMaybe<Array<InputMaybe<RegistrySortInput>>>;
};

export type RootQueryTypeListMicrocreditRequestsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	filter?: InputMaybe<MicrocreditRequestFilterInput>;
	first?: InputMaybe<Scalars['Int']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	sort?: InputMaybe<Array<InputMaybe<MicrocreditRequestSortInput>>>;
};

export type RootQueryTypeMeArgs = {
	filter?: InputMaybe<UserFilterInput>;
};

export type S3File = {
	__typename?: 'S3File';
	presignedGet?: Maybe<Scalars['String']['output']>;
};

export type S3PresignedPost = {
	__typename?: 'S3PresignedPost';
	fields: Array<S3PresignedPostField>;
	uri: Scalars['String']['output'];
};

export type S3PresignedPostField = {
	__typename?: 'S3PresignedPostField';
	name: Scalars['String']['output'];
	value: Scalars['String']['output'];
};

export type SolveRegistryCorrectionsInput = {
	birthInformation?: InputMaybe<RegistryBirthInformationInput>;
	officialAddress?: InputMaybe<RegistryOfficialAddressInput>;
	personalInformation?: InputMaybe<RegistryPersonalInformationInput>;
	proofOfLife?: InputMaybe<RegistryProofOfLifeInput>;
	taxInformation?: InputMaybe<RegistryTaxInformationInput>;
};

/** The result of the :solve_registry_corrections mutation */
export type SolveRegistryCorrectionsResult = {
	__typename?: 'SolveRegistryCorrectionsResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<Registry>;
};

export enum SortOrder {
	ASC = 'ASC',
	ASC_NULLS_FIRST = 'ASC_NULLS_FIRST',
	ASC_NULLS_LAST = 'ASC_NULLS_LAST',
	DESC = 'DESC',
	DESC_NULLS_FIRST = 'DESC_NULLS_FIRST',
	DESC_NULLS_LAST = 'DESC_NULLS_LAST'
}

export enum TaxRegimeCode {
	CODE_605 = 'CODE_605',
	CODE_606 = 'CODE_606',
	CODE_608 = 'CODE_608',
	CODE_611 = 'CODE_611',
	CODE_612 = 'CODE_612',
	CODE_614 = 'CODE_614',
	CODE_615 = 'CODE_615',
	CODE_616 = 'CODE_616',
	CODE_621 = 'CODE_621',
	CODE_622 = 'CODE_622',
	CODE_626 = 'CODE_626',
	CODE_629 = 'CODE_629',
	CODE_630 = 'CODE_630'
}

export enum TransportationMethod {
	BIKE = 'BIKE',
	CAR = 'CAR',
	PUBLIC_TRANSPORT = 'PUBLIC_TRANSPORT',
	WALK = 'WALK'
}

export type TrullyInformation = {
	__typename?: 'TrullyInformation';
	city?: Maybe<Scalars['String']['output']>;
	colony?: Maybe<Scalars['String']['output']>;
	curp?: Maybe<Scalars['String']['output']>;
	dateOfBirth?: Maybe<Scalars['Date']['output']>;
	email: Scalars['String']['output'];
	externalNumber?: Maybe<Scalars['String']['output']>;
	firstLastName?: Maybe<Scalars['String']['output']>;
	internalNumber?: Maybe<Scalars['String']['output']>;
	municipalityOrDelegation?: Maybe<Scalars['String']['output']>;
	names?: Maybe<Scalars['String']['output']>;
	phoneNumber?: Maybe<Scalars['String']['output']>;
	postalCode?: Maybe<Scalars['String']['output']>;
	requestId?: Maybe<Scalars['String']['output']>;
	rfc?: Maybe<Scalars['String']['output']>;
	secondLastName?: Maybe<Scalars['String']['output']>;
	state?: Maybe<Scalars['String']['output']>;
	street?: Maybe<Scalars['String']['output']>;
	userId: Scalars['ID']['output'];
};

export type UpdateTrullyInformationInput = {
	trullyInformation?: InputMaybe<AntifraudAnalysisTrullyInformationInput>;
};

/** The result of the :update_trully_information mutation */
export type UpdateTrullyInformationResult = {
	__typename?: 'UpdateTrullyInformationResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<AntifraudAnalysis>;
};

export type UploadIneBackInput = {
	contentLengthBytes: Scalars['Int']['input'];
	mimeType: Scalars['String']['input'];
};

export type UploadIneFrontInput = {
	contentLengthBytes: Scalars['Int']['input'];
	mimeType: Scalars['String']['input'];
};

export type UploadProofOfAddressInput = {
	contentLengthBytes: Scalars['Int']['input'];
	mimeType: Scalars['String']['input'];
};

export type UploadSelfieInput = {
	contentLengthBytes: Scalars['Int']['input'];
	mimeType: Scalars['String']['input'];
};

export type UploadTaxStatusCertificateInput = {
	contentLengthBytes: Scalars['Int']['input'];
	mimeType: Scalars['String']['input'];
};

export type User = {
	__typename?: 'User';
	confirmedAt?: Maybe<Scalars['DateTime']['output']>;
	email: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	isPhoneNumberConfirmed?: Maybe<Scalars['Boolean']['output']>;
	phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type UserFilterConfirmedAt = {
	eq?: InputMaybe<Scalars['DateTime']['input']>;
	greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['DateTime']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
	notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserFilterEmail = {
	eq?: InputMaybe<Scalars['String']['input']>;
	greaterThan?: InputMaybe<Scalars['String']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	in?: InputMaybe<Array<Scalars['String']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['String']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterId = {
	eq?: InputMaybe<Scalars['ID']['input']>;
	greaterThan?: InputMaybe<Scalars['ID']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	in?: InputMaybe<Array<Scalars['ID']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['ID']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type UserFilterInput = {
	and?: InputMaybe<Array<UserFilterInput>>;
	confirmedAt?: InputMaybe<UserFilterConfirmedAt>;
	email?: InputMaybe<UserFilterEmail>;
	id?: InputMaybe<UserFilterId>;
	isPhoneNumberConfirmed?: InputMaybe<UserFilterIsPhoneNumberConfirmed>;
	not?: InputMaybe<Array<UserFilterInput>>;
	or?: InputMaybe<Array<UserFilterInput>>;
	phoneNumber?: InputMaybe<UserFilterPhoneNumber>;
};

export type UserFilterIsPhoneNumberConfirmed = {
	eq?: InputMaybe<Scalars['Boolean']['input']>;
	greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
	in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['Boolean']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
	notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterPhoneNumber = {
	eq?: InputMaybe<Scalars['String']['input']>;
	greaterThan?: InputMaybe<Scalars['String']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	ilike?: InputMaybe<Scalars['String']['input']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['String']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
	like?: InputMaybe<Scalars['String']['input']>;
	notEq?: InputMaybe<Scalars['String']['input']>;
};
